'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var StyledErrorContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 4px 4px 8px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 4px 4px 8px;\n"])));
var Arrow = styled__default.span(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var Clear = styled__default(Arrow)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var ExclamationMark = styled__default.span(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.pink;
});
var StyledContainer = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledSelect = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 4px 40px 4px 16px;\n  height: 48px;\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n  transition: 0.3s;\n  &:hover {\n    border: 1px solid\n      ", ";\n  }\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 4px 40px 4px 16px;\n  height: 48px;\n  border: 1px solid\n    ",
    ";\n  border-radius: 4px;\n  background-color: ",
    ";\n  width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n  transition: 0.3s;\n  &:hover {\n    border: 1px solid\n      ",
    ";\n  }\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme, isOpen = _a.isOpen, errored = _a.errored, disabled = _a.disabled;
    var color = theme.colors.greys.adminGreyMedium;
    if (isOpen && !disabled) {
        color = theme.colors.primary;
    }
    else if (errored) {
        color = theme.colors.admin.pink;
    }
    return color;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return (disabled
        ? theme.colors.greys.adminGreyMedium : theme.colors.universal.white);
}, function (_a) {
    var theme = _a.theme, isOpen = _a.isOpen, errored = _a.errored, disabled = _a.disabled;
    var color = theme.colors.greys.adminGreyDark;
    if (isOpen && !disabled) {
        color = theme.colors.primary;
    }
    else if (disabled) {
        color = theme.colors.greys.adminGreyMedium;
    }
    else if (errored) {
        color = theme.colors.admin.pink;
    }
    return color;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled
        ? "\n  cursor: not-allowed;\n"
        : '');
});
var StyledLabel = styled__default.p(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  font: 14px ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 22px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  pointer-events: none;\n  margin: 0;\n  color: ", ";\n"], ["\n  width: 100%;\n  font: 14px ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 22px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  pointer-events: none;\n  margin: 0;\n  color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, isSelectActive = _a.isSelectActive;
    return (isSelectActive
        ? theme.colors.fontColor : theme.colors.greys.adminGreyMediumAlt);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.Arrow = Arrow;
exports.Clear = Clear;
exports.ExclamationMark = ExclamationMark;
exports.StyledContainer = StyledContainer;
exports.StyledErrorContainer = StyledErrorContainer;
exports.StyledLabel = StyledLabel;
exports.StyledSelect = StyledSelect;
